module.exports = __webpack_public_path__ + "static/media/kofferbak markt.7ff1f594.jpg";